import { FC } from 'react'
import styled from 'styled-components'
import Button from '@app.components/Button'
import CloseIcon from 'svgIcons/CloseIcon'

interface DeleteItemButtonProps {
  onClick: () => void
}

const DeleteItemButton: FC<DeleteItemButtonProps> = ({ onClick }) => {
  return (
    <StyledWrapper onClick={onClick}>
      <CloseIcon fill="rgba(0, 0, 0, 0.54)" />
    </StyledWrapper>
  )
}

export default DeleteItemButton

const StyledWrapper = styled(Button)`
  background-color: transparent;
  &:hover {
    background-color: transparent;
  }

  .icon {
    path > {
      fill: rgba(0, 0, 0, 0.54);
    }
    width: 24px;
    height: 24px;
  }
`
